// extracted by mini-css-extract-plugin
export var container = "_a7-0";
export var containerTopRight = "_a7-1";